import CertificatesofCompletionService from './completioncertficate.service'

class CertficateService extends CertificatesofCompletionService {
  static get resource() {
    return ''
  }
}

export default CertficateService
